module.exports = __webpack_public_path__ + "img/step1-mobile.2e8ebaea.jpg";